import { usePresenceContext } from "../providers/PresenceProvider"

/**
 * Convenience hook for presence state.
 *
 * @example
 * const { isOnline, onlineUsers, connectionState } = usePresence()
 * const online = isOnline(user.id)
 */
const usePresence = () => {
  const {
    onlineUsers,
    isOnline,
    getOnlineUsers,
    connectionState,
    isSubscribed,
    presenceChannel,
    isAuthSkipped,
  } = usePresenceContext()

  return {
    onlineUsers,
    isOnline,
    getOnlineUsers,
    connectionState,
    isSubscribed,
    presenceChannel,
    isAuthSkipped,
  }
}

export default usePresence
